import xhrWrapper from "helpers/xhr-wrapper";
import { Paths } from "types/api";

const { apicalls } = xhrWrapper;

/**
 * amazon ad group
 */

/**
 * List available Amazon ad groups
 */
export const listAmazonAdGroups = (
  params: Paths.ListAmazonAdGroups.QueryParameters
) =>
  apicalls.get<
    Paths.ListAmazonAdGroups.QueryParameters,
    Paths.ListAmazonAdGroups.Responses.$200
  >("ams/ad_groups", params);

// POST /ams/ad_groups

/**
 * Bulk archive Amazon ad groups
 */
export const bulkArchiveAmazonAdGroups = (
  params: Paths.BulkArchiveAmazonAdGroups.RequestBody
) =>
  apicalls.post<
    Paths.BulkArchiveAmazonAdGroups.RequestBody,
    Paths.BulkArchiveAmazonAdGroups.Responses.$202
  >("ams/ad_groups/bulk_archive", params);

/**
 * Bulk enable Amazon ad groups
 */
export const bulkEnableAmazonAdGroups = (
  params: Paths.BulkEnableAmazonAdGroups.RequestBody
) =>
  apicalls.post<
    Paths.BulkEnableAmazonAdGroups.RequestBody,
    Paths.BulkEnableAmazonAdGroups.Responses.$202
  >("ams/ad_groups/bulk_enable", params);

/**
 * Bulk pause Amazon ad groups
 */
export const bulkPauseAmazonAdGroups = (
  params: Paths.BulkPauseAmazonAdGroups.RequestBody
) =>
  apicalls.post<
    Paths.BulkPauseAmazonAdGroups.RequestBody,
    Paths.BulkPauseAmazonAdGroups.Responses.$202
  >("ams/ad_groups/bulk_pause", params);

/**
 * Export Amazon AdGroups
 */
export const exportAmazonAdGroups = (
  params: Paths.ExportAmazonAdGroups.RequestBody
) =>
  apicalls.post<
    Paths.ExportAmazonAdGroups.RequestBody,
    Paths.ExportAmazonAdGroups.Responses.$202
  >("ams/ad_groups/export", params);

/**
 * Search available Amazon ad groups
 */
export const searchAmazonAdGroups = (
  params: Paths.SearchAmazonAdGroups.RequestBody
) =>
  apicalls.post<
    Paths.SearchAmazonAdGroups.RequestBody,
    Paths.SearchAmazonAdGroups.Responses.$200
  >("ams/ad_groups/search", params);

/**
 * Get search totals for Amazon ad groups
 */
export const searchTotalsForAmazonAdGroups = (
  params: Paths.SearchTotalsForAmazonAdGroups.RequestBody
) =>
  apicalls.post<
    Paths.SearchTotalsForAmazonAdGroups.RequestBody,
    Paths.SearchTotalsForAmazonAdGroups.Responses.$200
  >("ams/ad_groups/totals", params);

// DELETE /ams/ad_groups/{ad_group_id}
// GET /ams/ad_groups/{ad_group_id}
// PUT /ams/ad_groups/{ad_group_id}

/**
 * amazon ad group collection
 */

/**
 * List Amazon ad group collections.
 */
export const listAmazonAdGroupCollections = (
  params: Paths.ListAmazonAdGroupCollections.QueryParameters
) =>
  apicalls.get<
    Paths.ListAmazonAdGroupCollections.QueryParameters,
    Paths.ListAmazonAdGroupCollections.Responses.$200
  >("ams/ad_group_collections", params);

/**
 * Create Amazon ad group collection
 */
export const createAmazonAdGroupCollection = (
  params: Paths.CreateAmazonAdGroupCollection.RequestBody
) =>
  apicalls.post<
    Paths.CreateAmazonAdGroupCollection.RequestBody,
    Paths.CreateAmazonAdGroupCollection.Responses.$201
  >("ams/ad_group_collections", params);

/**
 * Bulk add Amazon ad groups to Amazon ad group collections
 */
export const bulkAddAdGroupsToAmazonAdGroupCollections = (
  params: Paths.BulkAddAdGroupsToAmazonAdGroupCollections.RequestBody
) =>
  apicalls.post<
    Paths.BulkAddAdGroupsToAmazonAdGroupCollections.RequestBody,
    Paths.BulkAddAdGroupsToAmazonAdGroupCollections.Responses.$202
  >("ams/ad_group_collections/bulk_add_ad_groups", params);

/**
 * Bulk remove Amazon ad groups to Amazon ad group collections
 */
export const bulkRemoveAdGroupsFromAmazonAdGroupCollections = (
  params: Paths.BulkRemoveAdGroupsFromAmazonAdGroupCollections.RequestBody
) =>
  apicalls.post<
    Paths.BulkRemoveAdGroupsFromAmazonAdGroupCollections.RequestBody,
    Paths.BulkRemoveAdGroupsFromAmazonAdGroupCollections.Responses.$202
  >("ams/ad_group_collections/bulk_remove_ad_groups", params);

/**
 * Delete Amazon ad group collection
 */
export const deleteAmazonAdGroupCollection = (
  params: Paths.DeleteAmazonAdGroupCollection.PathParameters
) => apicalls.delete(`ams/ad_group_collections/${params.collection_id}`);

// GET /ams/ad_group_collections/{collection_id}

/**
 * Update Amazon ad group collection
 */
export const updateAmazonAdGroupCollection = (
  params: Paths.UpdateAmazonAdGroupCollection.PathParameters &
    Paths.UpdateAmazonAdGroupCollection.RequestBody
) =>
  apicalls.put<
    Paths.UpdateAmazonAdGroupCollection.RequestBody,
    Paths.UpdateAmazonAdGroupCollection.Responses.$200
  >(`ams/ad_group_collections/${params.collection_id}`, params);

/**
 * List ad groups attached to the ad group collection
 */
export const listAmazonAdGroupsForAdGroupCollection = (
  params: Paths.ListAmazonAdGroupsForAdGroupCollection.PathParameters &
    Paths.ListAmazonAdGroupsForAdGroupCollection.QueryParameters
) =>
  apicalls.get<
    Paths.ListAmazonAdGroupsForAdGroupCollection.QueryParameters,
    Paths.ListAmazonAdGroupsForAdGroupCollection.Responses.$200
  >(`ams/ad_group_collections/${params.collection_id}/ad_groups`, params);

/**
 * amazon asin
 */

/**
 * Bulk enable Amazon ASINs
 */
export const bulkEnableAmazonAsins = (
  params: Paths.BulkEnableAmazonAsins.RequestBody
) =>
  apicalls.post<
    Paths.BulkEnableAmazonAsins.RequestBody,
    Paths.BulkEnableAmazonAsins.Responses.$202
  >("ams/asins/bulk_enable", params);

/**
 * Bulk pause Amazon ASINs
 */
export const bulkPauseAmazonAsins = (
  params: Paths.BulkPauseAmazonAsins.RequestBody
) =>
  apicalls.post<
    Paths.BulkPauseAmazonAsins.RequestBody,
    Paths.BulkPauseAmazonAsins.Responses.$202
  >("ams/asins/bulk_pause", params);

/**
 * Export Amazon ASINs
 */
export const exportAmazonAsins = (
  params: Paths.ExportAmazonAsins.RequestBody
) =>
  apicalls.post<
    Paths.ExportAmazonAsins.RequestBody,
    Paths.ExportAmazonAsins.Responses.$202
  >("ams/asins/export", params);

/**
 * Search Amazon asins
 */
export const searchAmazonAsins = (
  params: Paths.SearchAmazonAsins.RequestBody
) =>
  apicalls.post<
    Paths.SearchAmazonAsins.RequestBody,
    Paths.SearchAmazonAsins.Responses.$200
  >("ams/asins/search", params);

/**
 * Get search totals for Amazon asin
 */
export const searchTotalsforAmazonAsins = (
  params: Paths.SearchTotalsForAmazonAsins.RequestBody
) =>
  apicalls.post<
    Paths.SearchTotalsForAmazonAsins.RequestBody,
    Paths.SearchTotalsForAmazonAsins.Responses.$200
  >("ams/asins/totals", params);

/**
 * amazon asin collection
 */

/**
 * List Amazon ASIN collections
 */
export const listAmazonAsinCollections = (
  params: Paths.ListAmazonAsinCollections.QueryParameters
) =>
  apicalls.get<
    Paths.ListAmazonAsinCollections.QueryParameters,
    Paths.ListAmazonAsinCollections.Responses.$200
  >("ams/asin_collections", params);

/**
 * Create Amazon ASIN collection
 */
export const createAmazonAsinCollection = (
  params: Paths.CreateAmazonAsinCollection.RequestBody
) =>
  apicalls.post<
    Paths.CreateAmazonAsinCollection.RequestBody,
    Paths.CreateAmazonAsinCollection.Responses.$201
  >("ams/asin_collections", params);

/**
 * Bulk enable an Amazon asin collection
 */
export const bulkEnableAmazonAsinCollections = (
  params: Paths.BulkEnableAmazonAsinCollections.RequestBody
) =>
  apicalls.post<
    Paths.BulkEnableAmazonAsinCollections.RequestBody,
    Paths.BulkEnableAmazonAsinCollections.Responses.$202
  >("ams/asins_collections/bulk_enable", params);

/**
 * Bulk pause an Amazon asin collection
 */
export const bulkPauseAmazonAsinCollections = (
  params: Paths.BulkPauseAmazonAsinCollections.RequestBody
) =>
  apicalls.post<
    Paths.BulkPauseAmazonAsinCollections.RequestBody,
    Paths.BulkPauseAmazonAsinCollections.Responses.$202
  >("ams/asins_collections/bulk_pause", params);

/**
 * Delete Amazon ASIN collection
 */
export const deleteAmazonAsinCollection = (
  params: Paths.DeleteAmazonAsinCollection.PathParameters
) => apicalls.delete(`ams/asin_collections/${params.collection_id}`);

// GET /ams/asin_collections/{collection_id}

/**
 * Update Amazon ASIN collection
 */
export const updateAmazonAsinCollection = (
  params: Paths.UpdateAmazonAsinCollection.PathParameters &
    Paths.UpdateAmazonAsinCollection.RequestBody
) =>
  apicalls.put<
    Paths.UpdateAmazonAsinCollection.RequestBody,
    Paths.UpdateAmazonAsinCollection.Responses.$200
  >(`ams/asin_collections/${params.collection_id}`, params);

// POST /ams/asin_collections/{collection_id}/add_product

/**
 * Add Amazon products to an ASIN collection
 */
export const addAmazonProductsToAsinCollection = (
  params: Paths.AddAmazonProductsToAsinCollection.PathParameters &
    Paths.AddAmazonProductsToAsinCollection.RequestBody
) =>
  apicalls.post<
    Paths.AddAmazonProductsToAsinCollection.RequestBody,
    Paths.AddAmazonProductsToAsinCollection.Responses.$200
  >(`ams/asin_collections/${params.collection_id}/add_products`, {
    asins: params.asins,
  });

/**
 * List Amazon products in an ASIN collection
 */
export const listAmazonProductsInAsinCollection = (
  params: Paths.ListAmazonProductsInAsinCollection.PathParameters
) =>
  apicalls.get<
    undefined,
    Paths.ListAmazonProductsInAsinCollection.Responses.$200
  >(`ams/asin_collections/${params.collection_id}/products`);

// POST /ams/asin_collections/{collection_id}/remove_product

/**
 * Remove Amazon products from an ASIN collection
 */
export const removeAmazonProductsFromAsinCollection = (
  params: Paths.RemoveAmazonProductsFromAsinCollection.PathParameters &
    Paths.RemoveAmazonProductsFromAsinCollection.RequestBody
) =>
  apicalls.post<
    Paths.RemoveAmazonProductsFromAsinCollection.RequestBody,
    Paths.RemoveAmazonProductsFromAsinCollection.Responses.$200
  >(`ams/asin_collections/${params.collection_id}/remove_products`, {
    asins: params.asins,
  });

/**
 * amazon bid adjustment
 */

/**
 * Create Amazon bid adjustment
 */
export const createAmazonBidAdjustment = (
  params: Paths.CreateAmazonBidAdjustment.RequestBody
) =>
  apicalls.post<
    Paths.CreateAmazonBidAdjustment.RequestBody,
    Paths.CreateAmazonBidAdjustment.Responses.$200
  >("ams/bid_adjustments", params);

// DELETE /ams/bid_adjustments
// GET /ams/bid_adjustments/{id}
// PUT /ams/bid_adjustments/{id}

/**
 * amazon bid adjustment setting
 */

/**
 * List Amazon bid adjustment settings
 */
export const listAmazonBidAdjustmentSettings = (
  params: Paths.ListAmazonBidAdjustmentSettings.QueryParameters
) =>
  apicalls.get<
    Paths.ListAmazonBidAdjustmentSettings.QueryParameters,
    Paths.ListAmazonBidAdjustmentSettings.Responses.$200
  >("ams/bid_adjustment_settings", params);

/**
 * Create Amazon bid adjustment setting
 */
export const createAmazonBidAdjustmentSetting = (
  params: Paths.CreateAmazonBidAdjustmentSetting.RequestBody
) =>
  apicalls.post<
    Paths.CreateAmazonBidAdjustmentSetting.RequestBody,
    Paths.CreateAmazonBidAdjustmentSetting.Responses.$200
  >("ams/bid_adjustment_settings", params);

/**
 * Delete Amazon bid adjustment setting
 */
export const deleteAmazonBidAdjustment = (
  params: Paths.DeleteAmazonBidAdjustment.PathParameters
) => apicalls.delete(`ams/bid_adjustment_settings/${params.id}`);

/**
 * Get Amazon bid adjustment setting
 */
export const getAmazonBidAdjustmentSetting = (
  params: Paths.GetAmazonBidAdjustmentSetting.PathParameters
) =>
  apicalls.get<undefined, Paths.GetAmazonBidAdjustmentSetting.Responses.$200>(
    `ams/bid_adjustment_settings/${params.id}`
  );

/**
 * Update Amazon bid adjustment setting
 */
export const updateAmazonBidAdjustmentSetting = (
  params: Paths.UpdateAmazonBidAdjustmentSetting.PathParameters &
    Paths.UpdateAmazonBidAdjustmentSetting.RequestBody
) =>
  apicalls.put<
    Paths.UpdateAmazonBidAdjustmentSetting.RequestBody,
    Paths.UpdateAmazonBidAdjustmentSetting.Responses.$200
  >(`ams/bid_adjustment_settings/${params.id}`, params);

/**
 * amazon campaign
 */

// GET /ams/campaigns

/**
 * Archive multiple campaigns
 */
export const bulkArchiveAmazonCampaigns = (
  params: Paths.BulkArchiveAmazonCampaigns.RequestBody
) =>
  apicalls.post<
    Paths.BulkArchiveAmazonCampaigns.RequestBody,
    Paths.BulkArchiveAmazonCampaigns.Responses.$202
  >("ams/campaigns/bulk_archive", params);

/**
 * Enable multiple campaigns
 */
export const bulkEnableAmazonCampaigns = (
  params: Paths.BulkEnableAmazonCampaigns.RequestBody
) =>
  apicalls.post<
    Paths.BulkEnableAmazonCampaigns.RequestBody,
    Paths.BulkEnableAmazonCampaigns.Responses.$202
  >("ams/campaigns/bulk_enable", params);

/**
 * Pause multiple campaigns
 */
export const bulkPauseAmazonCampaigns = (
  params: Paths.BulkPauseAmazonCampaigns.RequestBody
) =>
  apicalls.post<
    Paths.BulkPauseAmazonCampaigns.RequestBody,
    Paths.BulkPauseAmazonCampaigns.Responses.$202
  >("ams/campaigns/bulk_pause", params);

/**
 * Export Amazon Campaigns
 */
export const exportAmazonCampaigns = (
  params: Paths.ExportAmazonCampaigns.RequestBody
) =>
  apicalls.post<
    Paths.ExportAmazonCampaigns.RequestBody,
    Paths.ExportAmazonCampaigns.Responses.$202
  >("ams/campaigns/export", params);

// GET /ams/campaigns/out_of_budget

/**
 * Get a list of Amazon campaigns out of budget
 */
export const getAmazonCampaignsOutOfBudget = (
  params: Paths.GetAmazonCampaignsOutOfBudget.QueryParameters
) =>
  apicalls.get<
    Paths.GetAmazonCampaignsOutOfBudget.QueryParameters,
    Paths.GetAmazonCampaignsOutOfBudget.Responses.$200
  >(`ams/campaigns/out_of_budget`, params);

export const searchAmazonCampaigns = (
  params: Paths.SearchAmazonCampaigns.RequestBody
) =>
  apicalls.post<
    Paths.SearchAmazonCampaigns.RequestBody,
    Paths.SearchAmazonCampaigns.Responses.$200
  >(`ams/campaigns/search`, params);

// POST /ams/campaigns/search

/**
 * Get search totals for Amazon campaigns
 */
export const searchTotalsForAmazonCampaigns = (
  params: Paths.SearchTotalsForAmazonCampaigns.RequestBody
) =>
  apicalls.post<
    Paths.SearchTotalsForAmazonCampaigns.RequestBody,
    Paths.SearchTotalsForAmazonCampaigns.Responses.$200
  >("ams/campaigns/totals", params);

// GET /ams/campaigns/{campaign_id}

/**
 * List all Amazon ad groups attached to the Amazon campaign
 */
export const getAmazonCampaignAdGroups = (
  params: Paths.GetAmazonCampaignAdGroups.PathParameters &
    Paths.GetAmazonCampaignAdGroups.QueryParameters
) =>
  apicalls.get<
    Paths.GetAmazonCampaignAdGroups.QueryParameters,
    Paths.GetAmazonCampaignAdGroups.Responses.$200
  >(`ams/campaigns/${params.campaign_id}/ad_groups`, params);

/**
 * amazon campaign collections
 */

/**
 * List campaign collections
 */
export const listAmazonCampaignCollections = (
  params: Paths.ListAmazonCampaignCollections.QueryParameters = {}
) =>
  apicalls.get<
    Paths.ListAmazonCampaignCollections.QueryParameters,
    Paths.ListAmazonCampaignCollections.Responses.$200
  >("ams/campaign_collections", params);

/**
 * Create campaign collection
 */
export const createAmazonCampaignCollection = (
  params: Paths.CreateAmazonCampaignCollection.RequestBody
) =>
  apicalls.post<
    Paths.CreateAmazonCampaignCollection.RequestBody,
    Paths.CreateAmazonCampaignCollection.Responses.$201
  >("ams/campaign_collections", params);

/**
 * Bulk add Amazon campaigns to Amazon campaign collections
 */
export const bulkAddAmazonCampaignsToCampaignCollections = (
  params: Paths.BulkAddAmazonCampaignsToCampaignCollections.RequestBody
) =>
  apicalls.post<
    Paths.BulkAddAmazonCampaignsToCampaignCollections.RequestBody,
    Paths.BulkAddAmazonCampaignsToCampaignCollections.Responses.$202
  >("ams/campaign_collections/bulk_add_campaigns", params);

/**
 * Bulk remove Amazon campaigns from Amazon campaign collections
 */
export const bulkRemoveAmazonCampaignsFromCampaignCollections = (
  params: Paths.BulkRemoveAmazonCampaignsFromCampaignCollections.RequestBody
) =>
  apicalls.post<
    Paths.BulkRemoveAmazonCampaignsFromCampaignCollections.RequestBody,
    Paths.BulkRemoveAmazonCampaignsFromCampaignCollections.Responses.$202
  >("ams/campaign_collections/bulk_remove_campaigns", params);

/**
 * Delete Amazon campaign collection
 */
export const deleteAmazonCampaignCollection = (
  params: Paths.DeleteAmazonCampaignCollection.PathParameters
) => apicalls.delete(`ams/campaign_collections/${params.collection_id}`);

// GET /ams/campaign_collections/{collection_id}

/**
 * Update Amazon campaign collection
 */
export const updateAmazonCampaignCollection = (
  params: Paths.UpdateAmazonCampaignCollection.PathParameters &
    Paths.UpdateAmazonCampaignCollection.RequestBody
) =>
  apicalls.put<
    Paths.UpdateAmazonCampaignCollection.RequestBody,
    Paths.UpdateAmazonCampaignCollection.Responses.$200
  >(`ams/campaign_collections/${params.collection_id}`, params);

/**
 * Get Amazon campaign collections in the collection
 */
export const getAmazonCampaignCollectionCampaigns = (
  params: Paths.GetAmazonCampaignCollectionCampaigns.PathParameters
) =>
  apicalls.get<
    undefined,
    Paths.GetAmazonCampaignCollectionCampaigns.Responses.$200
  >(`ams/campaign_collections/${params.collection_id}/campaigns`);

/**
 * amazon keyword
 */

/**
 * Create Amazon keyword
 */
export const createAmazonKeyword = (
  params: Paths.CreateAmazonKeyword.RequestBody
) =>
  apicalls.post<
    Paths.CreateAmazonKeyword.RequestBody,
    Paths.CreateAmazonKeyword.Responses.$200
  >("ams/keywords", params);

/**
 * Adjust Amazon keywords
 */
export const adjustAmazonKeywordBids = (
  params: Paths.AdjustAmazonKeywordBids.RequestBody
) =>
  apicalls.post<
    Paths.AdjustAmazonKeywordBids.RequestBody,
    Paths.AdjustAmazonKeywordBids.Responses.$200
  >("ams/keywords/adjust_bids", params);

/**
 * Adjust Amazon keywords by ACoS
 */
export const adjustAmazonKeywordBidsByAcos = (
  params: Paths.AdjustAmazonKeywordBidsByAcos.RequestBody
) =>
  apicalls.post<
    Paths.AdjustAmazonKeywordBidsByAcos.RequestBody,
    Paths.AdjustAmazonKeywordBidsByAcos.Responses.$200
  >("ams/keywords/adjust_bids_by_acos", params);

/**
 * Bulk archive Amazon keywords
 */
export const bulkArchiveAmazonKeywords = (
  params: Paths.BulkArchiveAmazonKeywords.RequestBody
) =>
  apicalls.post<
    Paths.BulkArchiveAmazonKeywords.RequestBody,
    Paths.BulkArchiveAmazonKeywords.Responses.$202
  >("ams/keywords/bulk_archive", params);

/**
 * Bulk enable Amazon keywords
 */
export const bulkEnableAmazonKeywords = (
  params: Paths.BulkEnableAmazonKeywords.RequestBody
) =>
  apicalls.post<
    Paths.BulkEnableAmazonKeywords.RequestBody,
    Paths.BulkEnableAmazonKeywords.Responses.$202
  >("ams/keywords/bulk_enable", params);

/**
 * Bulk pause Amazon keywords
 */
export const bulkPauseAmazonKeywords = (
  params: Paths.BulkPauseAmazonKeywords.RequestBody
) =>
  apicalls.post<
    Paths.BulkPauseAmazonKeywords.RequestBody,
    Paths.BulkPauseAmazonKeywords.Responses.$202
  >("ams/keywords/bulk_pause", params);

// GET /ams/keywords/duplicate_competing

/**
 * Export Amazon Keywords
 */
export const exportAmazonKeywords = (
  params: Paths.ExportAmazonKeywords.RequestBody
) =>
  apicalls.post<
    Paths.ExportAmazonKeywords.RequestBody,
    Paths.ExportAmazonKeywords.Responses.$202
  >("ams/keywords/export", params);

/**
 * Search Amazon Keywords
 */
export const searchAmazonKeywords = (
  params: Paths.SearchAmazonKeywords.RequestBody
) =>
  apicalls.post<
    Paths.SearchAmazonKeywords.RequestBody,
    Paths.SearchAmazonKeywords.Responses.$200
  >("ams/keywords/search", params);

/**
 * Get Amazon Keyword performance statistics
 */
export const getAmazonKeywordPerformanceStatistics = (
  params: Paths.GetAmazonKeywordPerformanceStatistics.RequestBody
) =>
  apicalls.post<
    Paths.GetAmazonKeywordPerformanceStatistics.RequestBody,
    Paths.GetAmazonKeywordPerformanceStatistics.Responses.$200
  >(`ams/keywords/statistics`, params);

/**
 * Search Amazon Keywords
 */
export const searchTotalsForAmazonKeywords = (
  params: Paths.SearchTotalsForAmazonKeywords.RequestBody
) =>
  apicalls.post<
    Paths.SearchTotalsForAmazonKeywords.RequestBody,
    Paths.SearchTotalsForAmazonKeywords.Responses.$200
  >("ams/keywords/totals", params);

/**
 * amazon negative keyword
 */

/**
 * Create an Amazon negative keyword
 */
export const createAmazonNegativeKeyword = (
  params: Paths.CreateAmazonNegativeKeyword.RequestBody
) =>
  apicalls.post<
    Paths.CreateAmazonNegativeKeyword.RequestBody,
    Paths.CreateAmazonNegativeKeyword.Responses.$202
  >("ams/negative_keywords", params);

/**
 * Delete an Amazon negative keyword
 */
export const deleteAmazonNegativeKeyword = (
  params: Paths.DeleteAmazonNegativeKeyword.PathParameters
) => apicalls.delete(`ams/negative_keywords/${params.id}`);

/**
 * Get an Amazon negative keyword
 */
export const getAmazonNegativeKeyword = (
  params: Paths.GetAmazonNegativeKeyword.PathParameters
) =>
  apicalls.get<undefined, Paths.GetAmazonNegativeKeyword.Responses.$200>(
    `ams/negative_keywords/${params.id}`
  );

/**
 * amazon negative keyword list
 */

/**
 * List Amazon negative keyword lists
 */
export const listAmazonNegativeKeywordLists = (
  params: Paths.ListAmazonNegativeKeywordLists.QueryParameters
) =>
  apicalls.get<
    Paths.ListAmazonNegativeKeywordLists.QueryParameters,
    Paths.ListAmazonNegativeKeywordLists.Responses.$200
  >("ams/negative_keyword_lists", params);

/**
 * Create an Amazon negative keyword list
 */
export const createAmazonNegativeKeywordList = (
  params: Paths.CreateAmazonNegativeKeywordList.RequestBody
) =>
  apicalls.post<
    Paths.CreateAmazonNegativeKeywordList.RequestBody,
    Paths.CreateAmazonNegativeKeywordList.Responses.$200
  >("ams/negative_keyword_lists", params);

/**
 * Delete an Amazon negative keyword list
 */
export const deleteAmazonNegativeKeywordList = (
  params: Paths.DeleteAmazonNegativeKeywordList.PathParameters
) => apicalls.delete(`ams/negative_keyword_lists/${params.list_id}`);

/**
 * Get Amazon negative keyword list
 */
export const getAmazonNegativeKeywordList = (
  params: Paths.GetAmazonNegativeKeywordList.PathParameters
) =>
  apicalls.get<undefined, Paths.GetAmazonNegativeKeywordList.Responses.$200>(
    `ams/negative_keyword_lists/${params.list_id}`
  );

/**
 * Update an Amazon negative keyword list
 */
export const updateAmazonNegativeKeywordList = (
  params: Paths.UpdateAmazonNegativeKeywordList.PathParameters &
    Paths.UpdateAmazonNegativeKeywordList.RequestBody
) =>
  apicalls.put<
    Paths.UpdateAmazonNegativeKeywordList.RequestBody,
    Paths.UpdateAmazonNegativeKeywordList.Responses.$200
  >(`ams/negative_keyword_lists/${params.list_id}`, params);

/**
 * Add Amazon campaign to a negative keyword list
 */
export const addAmazonCampaignToNegativeKeywordList = (
  params: Paths.AddAmazonCampaignToNegativeKeywordList.PathParameters &
    Paths.AddAmazonCampaignToNegativeKeywordList.RequestBody
) =>
  apicalls.post<
    Paths.AddAmazonCampaignToNegativeKeywordList.RequestBody,
    Paths.AddAmazonCampaignToNegativeKeywordList.Responses.$202
  >(`ams/negative_keyword_lists/${params.list_id}/add_campaigns`, params);

/**
 * Get Amazon negative keyword list changes
 */
export const getAmazonNegativeKeywordListCampaigns = (
  params: Paths.GetAmazonNegativeKeywordListCampaigns.PathParameters
) =>
  apicalls.get<
    undefined,
    Paths.GetAmazonNegativeKeywordListCampaigns.Responses.$200
  >(`ams/negative_keyword_lists/${params.list_id}/campaigns`);

/**
 * Get Amazon negative keyword list changes
 */
export const getAmazonNegativeKeywordListChanges = (
  params: Paths.GetAmazonNegativeKeywordListChanges.PathParameters
) =>
  apicalls.get<
    undefined,
    Paths.GetAmazonNegativeKeywordListChanges.Responses.$200
  >(`ams/negative_keyword_lists/${params.list_id}/changes`);

/**
 * Remove Amazon campaign from a negative keyword list
 */
export const removeAmazonCampaignFromNegativeKeywordList = (
  params: Paths.RemoveAmazonCampaignFromNegativeKeywordList.PathParameters &
    Paths.RemoveAmazonCampaignFromNegativeKeywordList.RequestBody
) =>
  apicalls.post<
    Paths.RemoveAmazonCampaignFromNegativeKeywordList.RequestBody,
    Paths.RemoveAmazonCampaignFromNegativeKeywordList.Responses.$202
  >(`ams/negative_keyword_lists/${params.list_id}/remove_campaigns`, params);

/**
 * amazon product ad
 */

/**
 * Bulk archive Amazon product ads
 */
export const bulkArchiveAmazonProductAds = (
  params: Paths.BulkArchiveAmazonProductAds.RequestBody
) =>
  apicalls.post<
    Paths.BulkArchiveAmazonProductAds.RequestBody,
    Paths.BulkArchiveAmazonProductAds.Responses.$202
  >("ams/product_ads/bulk_archive", params);

/**
 * Bulk enable Amazon product ads
 */
export const bulkEnableAmazonProductAds = (
  params: Paths.BulkEnableAmazonProductAds.RequestBody
) =>
  apicalls.post<
    Paths.BulkEnableAmazonProductAds.RequestBody,
    Paths.BulkEnableAmazonProductAds.Responses.$202
  >("ams/product_ads/bulk_enable", params);

/**
 * Bulk pause Amazon product ads
 */
export const bulkPauseAmazonProductAds = (
  params: Paths.BulkPauseAmazonProductAds.RequestBody
) =>
  apicalls.post<
    Paths.BulkPauseAmazonProductAds.RequestBody,
    Paths.BulkPauseAmazonProductAds.Responses.$202
  >("ams/product_ads/bulk_pause", params);

/**
 * Export Amazon ProductAds.
 */
export const exportAmazonProductAds = (
  params: Paths.ExportAmazonProductAds.RequestBody
) =>
  apicalls.post<
    Paths.ExportAmazonProductAds.RequestBody,
    Paths.ExportAmazonProductAds.Responses.$202
  >("ams/product_ads/export", params);

/**
 * Search Amazon product ads.
 */
export const searchAmazonProductAds = (
  params: Paths.SearchAmazonProductAds.RequestBody
) =>
  apicalls.post<
    Paths.SearchAmazonProductAds.RequestBody,
    Paths.SearchAmazonProductAds.Responses.$200
  >("ams/product_ads/search", params);

/**
 * Get search totals for Amazon product ads
 */
export const searchTotalsForAmazonProductAds = (
  params: Paths.SearchTotalsForAmazonProductAds.RequestBody
) =>
  apicalls.post<
    Paths.SearchTotalsForAmazonProductAds.RequestBody,
    Paths.SearchTotalsForAmazonProductAds.Responses.$200
  >("ams/product_ads/totals", params);

/**
 * amazon profile
 */

/**
 * Get Amazon profiles
 */
export const listAmazonProfiles = () =>
  apicalls.get<undefined, Paths.ListAmazonProfiles.Responses.$200>(
    "ams/profiles"
  );

// GET /ams/profiles/{profile_id}

/**
 * Get incorrect keyword broad matches
 */
export const getAmazonIncorrectKeywordBroadMatches = (
  params: Paths.GetAmazonIncorrectKeywordBroadMatches.PathParameters &
    Paths.GetAmazonIncorrectKeywordBroadMatches.QueryParameters
) =>
  apicalls.get<
    Paths.GetAmazonIncorrectKeywordBroadMatches.QueryParameters,
    Paths.GetAmazonIncorrectKeywordBroadMatches.Responses.$200
  >(`ams/profiles/${params.profile_id}/incorrect_broad_matches`, params);

/**
 * Get incorrect keyword exact matches
 */
export const getAmazonIncorrectKeywordExactMatches = (
  params: Paths.GetAmazonIncorrectKeywordExactMatches.PathParameters &
    Paths.GetAmazonIncorrectKeywordExactMatches.QueryParameters
) =>
  apicalls.get<
    Paths.GetAmazonIncorrectKeywordExactMatches.QueryParameters,
    Paths.GetAmazonIncorrectKeywordExactMatches.Responses.$200
  >(`ams/profiles/${params.profile_id}/incorrect_exact_matches`, params);

/**
 * Get Amazon non asin sales
 */
export const getAmazonNonAsinSales = (
  params: Paths.GetAmazonNonAsinSales.PathParameters &
    Paths.GetAmazonNonAsinSales.RequestBody
) =>
  apicalls.post<
    Paths.GetAmazonNonAsinSales.RequestBody,
    Paths.GetAmazonNonAsinSales.Responses.$200
  >(`ams/profiles/${params.profile_id}/non_asin_sales`, params);

/**
 * amazon search term
 */

/**
 * Search Amazon search term reports.
 *
 * @deprecated
 */
export const searchAmazonSearchTermReports = (
  params: Paths.SearchAmazonSearchTermReports.RequestBody
) =>
  apicalls.post<
    Paths.SearchAmazonSearchTermReports.RequestBody,
    Paths.SearchAmazonSearchTermReports.Responses.$200
  >("ams/search_term_reports/search", params);

/**
 * Get totals Amazon search term reports.
 */
export const searchTotalsForAmazonSearchTerms = (
  params: Paths.SearchTotalsForAmazonSearchTerms.RequestBody
) =>
  apicalls.post<
    Paths.SearchTotalsForAmazonSearchTerms.RequestBody,
    Paths.SearchTotalsForAmazonSearchTerms.Responses.$200
  >("ams/search_term_reports/totals", params);

/**
 * Export Amazon search term reports.
 */
export const exportAmazonSearchTerms = (
  params: Paths.ExportAmazonSearchTerms.RequestBody
) =>
  apicalls.post<
    Paths.ExportAmazonSearchTerms.RequestBody,
    Paths.ExportAmazonSearchTerms.Responses.$202
  >("ams/search_term_reports/export", params);

/**
 * auth
 */

/**
 * Creates an access token based on user credentials
 */
export const createAccessToken = (
  params: Paths.CreateAccessToken.RequestBody
) =>
  apicalls.post<
    Paths.CreateAccessToken.RequestBody,
    Paths.CreateAccessToken.Responses.$200
  >("auth/token/create", params);

export const refreshAccessToken = (
  params: Paths.RefreshAccessToken.RequestBody
) =>
  apicalls.post<
    Paths.RefreshAccessToken.RequestBody,
    Paths.RefreshAccessToken.Responses.$200
  >("auth/token/refresh", params);

/**
 * Get information on the access token
 */
export const aboutMe = () =>
  apicalls.get<undefined, Paths.AboutMe.Responses.$200>("auth/users/me");

/**
 * autobid
 */

// GET /autobid/rule_sets

/**
 * Create an autobid rule set
 */
export const createAutobidRuleSet = (
  params: Paths.CreateAutobidRuleSet.RequestBody
) =>
  apicalls.post<
    Paths.CreateAutobidRuleSet.RequestBody,
    Paths.CreateAutobidRuleSet.Responses.$201
  >(`autobid/rule_sets`, params);

/**
 * Bulk enable autobid rule sets
 */
export const bulkEnableAutobidRuleSets = (
  params: Paths.BulkEnableAutobidRuleSets.RequestBody
) =>
  apicalls.post<
    Paths.BulkEnableAutobidRuleSets.RequestBody,
    Paths.BulkEnableAutobidRuleSets.Responses.$202
  >(`autobid/rule_sets/bulk_enable`, params);

/**
 * Bulk pause autobid rule sets
 */
export const bulkPauseAutobidRuleSets = (
  params: Paths.BulkPauseAutobidRuleSets.RequestBody
) =>
  apicalls.post<
    Paths.BulkPauseAutobidRuleSets.RequestBody,
    Paths.BulkPauseAutobidRuleSets.Responses.$202
  >(`autobid/rule_sets/bulk_pause`, params);

/**
 * Search autobid rule sets
 */
export const listAutobidRuleSets = (
  params: Paths.ListAutobidRuleSets.QueryParameters
) =>
  apicalls.post<
    Paths.ListAutobidRuleSets.QueryParameters,
    Paths.ListAutobidRuleSets.Responses.$200
  >(`autobid/rule_sets/search`, params);

/**
 * Delete autobid rule set
 */
export const deleteAutobidRuleset = (
  params: Paths.DeleteAutobidRuleSet.PathParameters
) => apicalls.delete(`autobid/rule_sets/${params.rule_set_id}`);

/**
 * Get autobid rule set
 */
export const getAutobidRuleset = (
  params: Paths.GetAutobidRuleSet.PathParameters
) =>
  apicalls.get<undefined, Paths.GetAutobidRuleSet.Responses.$200>(
    `autobid/rule_sets/${params.rule_set_id}`
  );

/**
 * Update autobid rule set
 */
export const updateAutobidRuleset = ({
  rule_set_id,
  ...rest
}: Paths.UpdateAutobidRuleSet.PathParameters &
  Paths.UpdateAutobidRuleSet.RequestBody) =>
  apicalls.put<
    Paths.UpdateAutobidRuleSet.RequestBody,
    Paths.UpdateAutobidRuleSet.Responses.$200
  >(`autobid/rule_sets/${rule_set_id}`, rest);

/**
 * Add campaign collections to autobid rule set
 */
export const addAmazonCampaignCollectionsToAutobidRuleset = (
  params: Paths.AddAmazonCampaignCollectionsToAutobidRuleset.PathParameters &
    Paths.AddAmazonCampaignCollectionsToAutobidRuleset.RequestBody
) =>
  apicalls.post<
    Paths.AddAmazonCampaignCollectionsToAutobidRuleset.RequestBody,
    Paths.AddAmazonCampaignCollectionsToAutobidRuleset.Responses.$200
  >(`autobid/rule_sets/${params.rule_set_id}/add_campaign_collections`, params);

/**
 * List autobid rule set campaign collections
 */
export const listAutobidRuleSetCampaignCollections = (
  params: Paths.ListAutobidRuleSetCampaignCollections.PathParameters &
    Paths.ListAutobidRuleSetCampaignCollections.QueryParameters
) =>
  apicalls.get<
    Paths.ListAutobidRuleSetCampaignCollections.QueryParameters,
    Paths.ListAutobidRuleSetCampaignCollections.Responses.$200
  >(`autobid/rule_sets/${params.rule_set_id}/campaign_collections`);

/**
 * Remove campaign collections to autobid rule set
 */
export const removeAmazonCampaignCollectionsFromAutobidRuleset = (
  params: Paths.RemoveAmazonCampaignCollectionsFromAutobidRuleset.PathParameters &
    Paths.RemoveAmazonCampaignCollectionsFromAutobidRuleset.RequestBody
) =>
  apicalls.post<
    Paths.RemoveAmazonCampaignCollectionsFromAutobidRuleset.RequestBody,
    Paths.RemoveAmazonCampaignCollectionsFromAutobidRuleset.Responses.$200
  >(
    `autobid/rule_sets/${params.rule_set_id}/remove_campaign_collections`,
    params
  );

/**
 * automation
 */

export const searchAutobidRuleSets = (
  params: Paths.SearchAutobidRuleSets.RequestBody
) =>
  apicalls.post<
    Paths.SearchAutobidRuleSets.RequestBody,
    Paths.SearchAutobidRuleSets.Responses.$200
  >("automation/autobid/rulesets/search", params);

/**
 * instacart dashboard
 */

/**
 * Get Amazon cumulative spend
 */
export const getInstacartSpendCumulativeSpend = (
  params: Paths.GetInstacartSpendCumulativeSpend.QueryParameters
) =>
  apicalls.get<
    Paths.GetInstacartSpendCumulativeSpend.QueryParameters,
    Paths.GetInstacartSpendCumulativeSpend.Responses.$200
  >("dashboard/instacart/spend/cumulative", params);

/**
 * Get Amazon spend pacing
 */
export const getInstacartSpendPacing = (
  params: Paths.GetInstacartSpendPacing.RequestBody
) =>
  apicalls.post<
    Paths.GetInstacartSpendPacing.RequestBody,
    Paths.GetInstacartSpendPacing.Responses.$200
  >("dashboard/instacart/spend/pacing", params);

/**
 * Get Instacart performance by ad type statistics
 */
export const getInstacartPerformanceByAdTypes = (
  params: Paths.GetInstacartPerformanceByAdTypes.RequestBody
) =>
  apicalls.post<
    Paths.GetInstacartPerformanceByAdTypes.RequestBody,
    Paths.GetInstacartPerformanceByAdTypes.Responses.$200
  >("dashboard/instacart/statistics/ad_types", params);

/**
 * Get Instacart performance by brand type statistics
 */
export const getInstacartPerformanceByBrandTypes = (
  params: Paths.GetInstacartPerformanceByBrandTypes.RequestBody
) =>
  apicalls.post<
    Paths.GetInstacartPerformanceByBrandTypes.RequestBody,
    Paths.GetInstacartPerformanceByBrandTypes.Responses.$200
  >("dashboard/instacart/statistics/brand_types", params);

/**
 * Get Instacart segmented performance statistics
 */
export const getInstacartSegmentedPerformanceStatistics = (
  params: Paths.GetInstacartSegmentedPerformanceStatistics.RequestBody
) =>
  apicalls.post<
    Paths.GetInstacartSegmentedPerformanceStatistics.RequestBody,
    Paths.GetInstacartSegmentedPerformanceStatistics.Responses.$200
  >("dashboard/instacart/statistics/segments", params);

/**
 * Get Instacart performance totals
 */
export const getInstacartPerformanceTotals = (
  params: Paths.GetInstacartPerformanceTotals.RequestBody
) =>
  apicalls.post<
    Paths.GetInstacartPerformanceTotals.RequestBody,
    Paths.GetInstacartPerformanceTotals.Responses.$200
  >("dashboard/instacart/statistics/totals", params);

/**
 * amazon dashboard
 */

/**
 * Get Amazon cumulative spend
 */
export const getAmazonSpendCumulativeSpend = (
  params: Paths.GetAmazonSpendCumulativeSpend.QueryParameters
) =>
  apicalls.get<
    Paths.GetAmazonSpendCumulativeSpend.QueryParameters,
    Paths.GetAmazonSpendCumulativeSpend.Responses.$200
  >(`dashboard/amazon/spend/cumulative`, params);

/**
 * Get Amazon spend pacing
 */
export const getAmazonSpendPacing = (
  params: Paths.GetAmazonSpendPacing.RequestBody
) =>
  apicalls.post<
    Paths.GetAmazonSpendPacing.RequestBody,
    Paths.GetAmazonSpendPacing.Responses.$200
  >(`dashboard/amazon/spend/pacing`, params);

/**
 * Get Amazon performance by ad type statistics
 */
export const getAmazonPerformanceByAdTypes = (
  params: Paths.GetAmazonPerformanceByAdTypes.RequestBody
) =>
  apicalls.post<
    Paths.GetAmazonPerformanceByAdTypes.RequestBody,
    Paths.GetAmazonPerformanceByAdTypes.Responses.$200
  >(`dashboard/amazon/statistics/ad_types`, params);

/**
 * Get Amazon performance by brand type statistics
 */
export const getAmazonPerformanceByBrandTypes = (
  params: Paths.GetAmazonPerformanceByBrandTypes.RequestBody
) =>
  apicalls.post<
    Paths.GetAmazonPerformanceByBrandTypes.RequestBody,
    Paths.GetAmazonPerformanceByBrandTypes.Responses.$200
  >(`dashboard/amazon/statistics/brand_types`, params);

/**
 * Get Amazon segmented performance statistics
 */
export const getAmazonSegmentedPerformanceStatistics = (
  params: Paths.GetAmazonSegmentedPerformanceStatistics.RequestBody
) =>
  apicalls.post<
    Paths.GetAmazonSegmentedPerformanceStatistics.RequestBody,
    Paths.GetAmazonSegmentedPerformanceStatistics.Responses.$200
  >(`dashboard/amazon/statistics/segments`, params);

/**
 * Get Amazon performance totals
 */
export const getAmazonPerformanceTotals = (
  params: Paths.GetAmazonPerformanceTotals.RequestBody
) =>
  apicalls.post<
    Paths.GetAmazonPerformanceTotals.RequestBody,
    Paths.GetAmazonPerformanceTotals.Responses.$200
  >("dashboard/amazon/statistics/totals", params);

/**
 * day parting
 */

/**
 * List day parting settings
 */
export const listDayPartingSettings = (
  params: Paths.ListDayPartingSettings.QueryParameters
) =>
  apicalls.get<
    Paths.ListDayPartingSettings.QueryParameters,
    Paths.ListDayPartingSettings.Responses.$200
  >(`day_parting/settings`, params);

export const searchDaypartingSettings = (params: any) =>
  apicalls.post(`day_parting/settings/search`, params);

/**
 * Create day parting settings
 */
export const createDaypartingSetting = (
  params: Paths.CreateDayPartingSetting.RequestBody
) =>
  apicalls.post<
    Paths.CreateDayPartingSetting.RequestBody,
    Paths.CreateDayPartingSetting.Responses.$201
  >(`day_parting/settings`, params);

/**
 * Bulk enable day parting settings
 */
export const bulkEnableDaypartingSettings = (
  params: Paths.BulkEnableDayPartingSettings.RequestBody
) =>
  apicalls.post<
    Paths.BulkEnableDayPartingSettings.RequestBody,
    Paths.BulkEnableDayPartingSettings.Responses.$202
  >(`day_parting/settings/bulk_enable`, params);

/**
 * Bulk pause day parting settings
 */
export const bulkPauseDaypartingSettings = (
  params: Paths.BulkPauseDayPartingSettings.RequestBody
) =>
  apicalls.post<
    Paths.BulkPauseDayPartingSettings.RequestBody,
    Paths.BulkPauseDayPartingSettings.Responses.$202
  >(`day_parting/settings/bulk_pause`, params);

/**
 * Delete day parting setting
 */
export const deleteDaypartingSetting = (
  params: Paths.DeleteDayPartingSetting.PathParameters
) => apicalls.delete(`day_parting/settings/${params.setting_id}`);

// GET /day_parting/settings/{setting_id}

/**
 * Update day parting setting
 */
export const updateDayPartingSetting = (
  params: Paths.UpdateDayPartingSetting.PathParameters &
    Paths.UpdateDayPartingSetting.RequestBody
) =>
  apicalls.put<
    Paths.UpdateDayPartingSetting.RequestBody,
    Paths.UpdateDayPartingSetting.Responses.$200
  >(`day_parting/settings/${params.setting_id}`, params);

/**
 * Add amazon campaign collections to day parting setting
 */
export const addAmazonCampaignCollectionsToDayPartingSetting = (
  params: Paths.AddAmazonCampaignCollectionsToDayPartingSetting.PathParameters &
    Paths.AddAmazonCampaignCollectionsToDayPartingSetting.RequestBody
) =>
  apicalls.post<
    Paths.AddAmazonCampaignCollectionsToDayPartingSetting.RequestBody,
    Paths.AddAmazonCampaignCollectionsToDayPartingSetting.Responses.$200
  >(
    `day_parting/settings/${params.setting_id}/add_campaign_collections`,
    params
  );

/**
 * List day parting setting campaign collections
 */
export const listDayPartingAmazonCampaignCollections = (
  params: Paths.ListDayPartingAmazonCampaignCollections.PathParameters &
    Paths.ListDayPartingAmazonCampaignCollections.QueryParameters
) =>
  apicalls.get<
    Paths.ListDayPartingAmazonCampaignCollections.QueryParameters,
    Paths.ListDayPartingAmazonCampaignCollections.Responses.$200
  >(`day_parting/settings/${params.setting_id}/campaign_collections`);

/**
 * Remove amazon campaign collections from day parting setting
 */
export const removeAmazonCampaignCollectionsFromDayPartingSetting = (
  params: Paths.RemoveAmazonCampaignCollectionsFromDayPartingSetting.PathParameters &
    Paths.RemoveAmazonCampaignCollectionsFromDayPartingSetting.RequestBody
) =>
  apicalls.post<
    Paths.RemoveAmazonCampaignCollectionsFromDayPartingSetting.RequestBody,
    Paths.RemoveAmazonCampaignCollectionsFromDayPartingSetting.Responses.$200
  >(
    `day_parting/settings/${params.setting_id}/remove_campaign_collections`,
    params
  );

/**
 * exports
 */

/**
 * Deletes the generated export document
 */
export const deleteExportDocument = (
  params: Paths.DeleteExportDocument.PathParameters
) => apicalls.delete(`exports/documents/${params.document_id}`);

/**
 * Get the information on the export document
 */
export const getExportDocument = (
  params: Paths.GetExportDocument.PathParameters
) =>
  apicalls.get<undefined, Paths.GetExportDocument.Responses.$200>(
    `exports/documents/${params.document_id}`
  );

/**
 * jobs
 */

// GET /jobs/{task_id}

/**
 * identity
 */

// GET /identity/accounts
// POST /identity/accounts
// GET /identity/accounts/{account_id}
// PUT /identity/accounts/{account_id}
// GET /identity/memberships
// POST /identity/memberships
// DELETE /identity/memberships/{membership_id}
// GET /identity/memberships/{membership_id}
// PUT /identity/memberships/{membership_id}

/**
 * Request a reset password token
 */
export const forgotPassword = (params: Paths.ForgotPassword.RequestBody) =>
  apicalls.post<
    Paths.ForgotPassword.RequestBody,
    Paths.ForgotPassword.Responses.$200
  >(`identity/passwords/forgot`, params);

/**
 * Request reset password
 */
export const resetPassword = (params: Paths.ResetPassword.RequestBody) =>
  apicalls.post<
    Paths.ResetPassword.RequestBody,
    Paths.ResetPassword.Responses.$200
  >(`identity/passwords/reset`, params);

// GET /identity/registration/{token}

/**
 * Complete user registration
 */
export const completeUserRegistration = (
  params: Paths.CompleteUserRegistration.PathParameters &
    Paths.CompleteUserRegistration.RequestBody
) =>
  apicalls.put<
    Paths.CompleteUserRegistration.RequestBody,
    Paths.CompleteUserRegistration.Responses.$200
  >(`identity/registration/${params.token}`, params);

/**
 * instacart accounts
 */

/**
 * List Instacart accounts
 */
export const listInstacartAccounts = (
  params: Paths.ListInstacartAccounts.QueryParameters
) =>
  apicalls.get<
    Paths.ListInstacartAccounts.QueryParameters,
    Paths.ListInstacartAccounts.Responses.$200
  >("instacart/accounts", params);

/**
 * Update Instacart account
 */
export const updateInstacartAccount = (
  params: Paths.UpdateInstacartAccount.PathParameters &
    Paths.UpdateInstacartAccount.RequestBody
) =>
  apicalls.put<
    Paths.UpdateInstacartAccount.RequestBody,
    Paths.UpdateInstacartAccount.Responses.$200
  >(`instacart/accounts/${params.id}`, params);

/**
 * instacart ad group collections
 */

/**
 * Create Instacart ad group collection
 */
export const createInstacartAdGroupCollection = (
  params: Paths.CreateInstacartAdGroupCollection.RequestBody
) =>
  apicalls.post<
    Paths.CreateInstacartAdGroupCollection.RequestBody,
    Paths.CreateInstacartCampaignCollection.Responses.$202
  >("instacart/ad_group_collections", params);

/**
 * Search Instacart ad group collections
 */
export const searchInstacartAdGroupCollections = (
  params: Paths.SearchInstacartAdGroupCollections.RequestBody
) =>
  apicalls.post<
    Paths.SearchInstacartAdGroupCollections.RequestBody,
    Paths.SearchInstacartAdGroupCollections.Responses.$200
  >("instacart/ad_group_collections/search", params);

export const bulkAddAdGroupsToInstacartAdGroupCollections = (
  params: Paths.BulkAddAdGroupsToInstacartAdGroupCollections.RequestBody
) =>
  apicalls.post<
    Paths.BulkAddAdGroupsToInstacartAdGroupCollections.RequestBody,
    Paths.BulkAddAdGroupsToInstacartAdGroupCollections.Responses.$202
  >("instacart/ad_group_collections/bulk_add", params);

export const bulkRemoveAdGroupsFromInstacartAdGroupCollections = (
  params: Paths.BulkRemoveAdGroupsFromInstacartAdGroupCollections.RequestBody
) =>
  apicalls.post<
    Paths.BulkRemoveAdGroupsFromInstacartAdGroupCollections.RequestBody,
    Paths.BulkRemoveAdGroupsFromInstacartAdGroupCollections.Responses.$202
  >("instacart/ad_group_collections/bulk_remove", params);

/**
 * Destroy Instacart ad group collection
 */
export const destroyInstacartAdGroupCollection = (
  params: Paths.DestroyInstacartAdGroupCollection.PathParameters
) => apicalls.delete(`instacart/ad_group_collections/${params.collection_id}`);

/**
 * Update Instacart ad group collection
 */
export const updateInstacartAdGroupCollection = (
  params: Paths.UpdateInstacartAdGroupCollection.PathParameters &
    Paths.UpdateInstacartAdGroupCollection.RequestBody
) =>
  apicalls.put<
    Paths.UpdateInstacartAdGroupCollection.RequestBody,
    Paths.UpdateInstacartAdGroupCollection.Responses.$200
  >(`instacart/ad_group_collections/${params.collection_id}`, params);

/**
 * Get Instacart ad group collection
 */
export const getInstacartAdGroupCollection = (
  params: Paths.GetInstacartAdGroupCollection.PathParameters
) =>
  apicalls.get<undefined, Paths.GetInstacartAdGroupCollection.Responses.$200>(
    `instacart/ad_group_collections/${params.collection_id}`
  );

/**
 * instacart ad groups
 */

/**
 * List Instacart ad groups
 */
export const listInstacartAdGroups = (
  params: Paths.ListInstacartAdGroups.QueryParameters
) =>
  apicalls.get<
    Paths.ListInstacartAdGroups.QueryParameters,
    Paths.ListInstacartAdGroups.Responses.$200
  >("instacart/ad_groups", params);

/**
 * Export Instacart Ad Groups
 */
export const exportInstacartAdGroups = (
  params: Paths.ExportInstacartAdGroups.RequestBody
) =>
  apicalls.post<
    Paths.ExportInstacartAdGroups.RequestBody,
    Paths.ExportInstacartAdGroups.Responses.$202
  >("instacart/ad_groups/export", params);

/**
 * Search available Instacart ad groups
 */
export const searchInstacartAdGroups = (
  params: Paths.SearchInstacartAdGroups.RequestBody
) =>
  apicalls.post<
    Paths.SearchInstacartAdGroups.RequestBody,
    Paths.SearchInstacartAdGroups.Responses.$200
  >("instacart/ad_groups/search", params);

/**
 * Search available Instacart ad groups
 */
export const searchTotalsForInstacartAdGroups = (
  params: Paths.SearchTotalsForInstacartAdGroups.RequestBody
) =>
  apicalls.post<
    Paths.SearchTotalsForInstacartAdGroups.RequestBody,
    Paths.SearchTotalsForInstacartAdGroups.Responses.$200
  >("instacart/ad_groups/totals", params);

/**
 * Get Instacart ad group
 */
export const getInstacartAdGroup = (
  params: Paths.GetInstacartAdGroup.PathParameters
) =>
  apicalls.get<undefined, Paths.GetInstacartAdGroup.Responses.$200>(
    `instacart/ad_groups/${params.id}`
  );

/**
 * instacart campaign collections
 */

/**
 * Create Instacart campaign collection
 */
export const createInstacartCampaignCollection = (
  params: Paths.CreateInstacartCampaignCollection.RequestBody
) =>
  apicalls.post<
    Paths.CreateInstacartCampaignCollection.RequestBody,
    Paths.CreateInstacartCampaignCollection.Responses.$202
  >("instacart/campaign_collections", params);

/**
 * Create Instacart campaign collection
 */
export const searchInstacartCampaignCollections = (
  params: Paths.SearchInstacartCampaignCollections.RequestBody
) =>
  apicalls.post<
    Paths.SearchInstacartCampaignCollections.RequestBody,
    Paths.SearchInstacartCampaignCollections.Responses.$200
  >("instacart/campaign_collections/search", params);

export const bulkAddCampaignsToInstacartCampaignCollections = (
  params: Paths.BulkAddCampaignsToInstacartCampaignCollections.RequestBody
) =>
  apicalls.post<
    Paths.BulkAddCampaignsToInstacartCampaignCollections.RequestBody,
    Paths.BulkAddCampaignsToInstacartCampaignCollections.Responses.$202
  >("instacart/campaign_collections/bulk_add", params);

export const bulkRemoveCampaignsFromInstacartCampaignCollections = (
  params: Paths.BulkRemoveCampaignsFromInstacartCampaignCollections.RequestBody
) =>
  apicalls.post<
    Paths.BulkRemoveCampaignsFromInstacartCampaignCollections.RequestBody,
    Paths.BulkRemoveCampaignsFromInstacartCampaignCollections.Responses.$202
  >("instacart/campaign_collections/bulk_remove", params);

/**
 * Destroy Instacart campaign collection
 */
export const destroyInstacartCampaignCollection = (
  params: Paths.DestroyInstacartCampaignCollection.PathParameters
) => apicalls.delete(`instacart/campaign_collections/${params.collection_id}`);

/**
 * Update Instacart campaign collection
 */
export const updateInstacartCampaignCollection = (
  params: Paths.UpdateInstacartCampaignCollection.PathParameters &
    Paths.UpdateInstacartAdGroupCollection.RequestBody
) =>
  apicalls.put<
    Paths.UpdateInstacartCampaignCollection.RequestBody,
    Paths.UpdateInstacartCampaignCollection.Responses.$200
  >(`instacart/campaign_collections/${params.collection_id}`, params);

/**
 * Get Instacart campaign collection
 */
export const getInstacartCampaignCollection = (
  params: Paths.GetInstacartCampaignCollection.PathParameters
) =>
  apicalls.get<undefined, Paths.GetInstacartCampaignCollection.Responses.$200>(
    `instacart/campaign_collections/${params.collection_id}`
  );

/**
 * instacart campaigns
 */

/**
 * List Instacart campaigns
 */
export const listInstacartCampaigns = (
  params: Paths.ListInstacartCampaigns.QueryParameters
) =>
  apicalls.get<
    Paths.ListInstacartCampaigns.QueryParameters,
    Paths.ListInstacartCampaigns.Responses.$200
  >("instacart/campaigns", params);

/**
 * Export Instacart campaigns
 */
export const exportInstacartCampaigns = (
  params: Paths.ExportInstacartCampaigns.RequestBody
) =>
  apicalls.post<
    Paths.ExportInstacartCampaigns.RequestBody,
    Paths.ExportInstacartCampaigns.Responses.$202
  >("instacart/campaigns/export", params);

/**
 * Search available Instacart campaigns
 */
export const searchInstacartCampaigns = (
  params: Paths.SearchInstacartCampaigns.RequestBody
) =>
  apicalls.post<
    Paths.SearchInstacartCampaigns.RequestBody,
    Paths.SearchInstacartCampaigns.Responses.$200
  >("instacart/campaigns/search", params);

/**
 * Get search totals for Instacart campaigns
 */
export const searchTotalsForInstacartCampaigns = (
  params: Paths.SearchTotalsForInstacartCampaigns.RequestBody
) =>
  apicalls.post<
    Paths.SearchTotalsForInstacartCampaigns.RequestBody,
    Paths.SearchTotalsForInstacartCampaigns.Responses.$200
  >("instacart/campaigns/totals", params);

/**
 * Get Instacart campaign
 */
export const getInstacartCampaign = (
  params: Paths.GetInstacartCampaign.PathParameters
) =>
  apicalls.get<undefined, Paths.GetInstacartCampaign.Responses.$200>(
    `instacart/campaigns/${params.id}`
  );

/**
 * instacart keywords
 */

/**
 * Export Instacart Keywords
 */
export const exportInstacartKeywords = (
  params: Paths.ExportInstacartKeywords.RequestBody
) =>
  apicalls.post<
    Paths.ExportInstacartKeywords.RequestBody,
    Paths.ExportInstacartKeywords.Responses.$202
  >("instacart/keywords/export", params);

/**
 * Search available Instacart keywords
 */
export const searchInstacartKeywords = (
  params: Paths.SearchInstacartKeywords.RequestBody
) =>
  apicalls.post<
    Paths.SearchInstacartKeywords.RequestBody,
    Paths.SearchInstacartKeywords.Responses.$200
  >("instacart/keywords/search", params);

/**
 * Get search totals for Instacart keywords
 */
export const searchTotalsForInstacartKeywords = (
  params: Paths.SearchTotalsForInstacartKeywords.RequestBody
) =>
  apicalls.post<
    Paths.SearchTotalsForInstacartKeywords.RequestBody,
    Paths.SearchTotalsForInstacartKeywords.Responses.$200
  >("instacart/keywords/totals", params);

/**
 * instacart products
 */

/**
 * List Instacart products
 */
export const listInstacartProducts = (
  params: Paths.ListInstacartProducts.QueryParameters
) =>
  apicalls.get<
    Paths.ListInstacartProducts.QueryParameters,
    Paths.ListInstacartProducts.Responses.$200
  >("instacart/products", params);

/**
 * Get Instacart product
 */
export const getInstacartProduct = (
  params: Paths.GetInstacartProduct.PathParameters
) =>
  apicalls.get<undefined, Paths.GetInstacartProduct.Responses.$200>(
    `instacart/products/${params.upc}`
  );

export const searchInstacartProducts = (
  params: Paths.SearchInstacartProducts.RequestBody
) =>
  apicalls.post<
    Paths.SearchInstacartProducts.RequestBody,
    Paths.SearchInstacartProducts.Responses.$200
  >("instacart/products/search", params);

export const searchTotalsForInstacartProducts = (
  params: Paths.SearchTotalsForInstacartProducts.RequestBody
) =>
  apicalls.post<
    Paths.SearchTotalsForInstacartProducts.RequestBody,
    Paths.SearchTotalsForInstacartProducts.Responses.$200
  >("instacart/products/totals", params);

/**
 * stats
 */

// POST /stats/amazon/profiles

/**
 * third_party
 */

// GET /instacart/integrations
// POST /instacart/integrations
// DELETE /instacart/integrations/{integration_id}
// PUT /instacart/integrations/{integration_id}
// GET /third_party/providers
// GET /third_party/providers/{provider_id}

/**
 * instacart product collections
 */

/**
 * Create Instacart product collection
 */
export const createInstacartProductCollection = (
  params: Paths.CreateInstacartProductCollection.RequestBody
) =>
  apicalls.post<
    Paths.CreateInstacartProductCollection.RequestBody,
    Paths.CreateInstacartProductCollection.Responses.$202
  >("instacart/product_collections", params);

/**
 * Create Instacart product collection
 */
export const searchInstacartProductCollections = (
  params: Paths.SearchInstacartProductCollections.RequestBody
) =>
  apicalls.post<
    Paths.SearchInstacartProductCollections.RequestBody,
    Paths.SearchInstacartProductCollections.Responses.$200
  >("instacart/product_collections/search", params);

export const bulkAddProductsToInstacartProductCollections = (
  params: Paths.BulkAddProductsToInstacartProductCollections.RequestBody
) =>
  apicalls.post<
    Paths.BulkAddProductsToInstacartProductCollections.RequestBody,
    Paths.BulkAddProductsToInstacartProductCollections.Responses.$202
  >("instacart/product_collections/bulk_add", params);

export const bulkRemoveProductsFromInstacartProductCollections = (
  params: Paths.BulkRemoveProductsFromInstacartProductCollections.RequestBody
) =>
  apicalls.post<
    Paths.BulkRemoveProductsFromInstacartProductCollections.RequestBody,
    Paths.BulkRemoveProductsFromInstacartProductCollections.Responses.$202
  >("instacart/product_collections/bulk_remove", params);

/**
 * Destroy Instacart product collection
 */
export const destroyInstacartProductCollection = (
  params: Paths.DestroyInstacartProductCollection.PathParameters
) => apicalls.delete(`instacart/product_collections/${params.collection_id}`);

/**
 * Update Instacart product collection
 */
export const updateInstacartProductCollection = (
  params: Paths.UpdateInstacartProductCollection.PathParameters &
    Paths.UpdateInstacartProductCollection.RequestBody
) =>
  apicalls.put<
    Paths.UpdateInstacartProductCollection.RequestBody,
    Paths.UpdateInstacartProductCollection.Responses.$200
  >(`instacart/product_collections/${params.collection_id}`, params);

/**
 * Get Instacart product collection
 */
export const getInstacartProductCollection = (
  params: Paths.GetInstacartProductCollection.PathParameters
) =>
  apicalls.get<undefined, Paths.GetInstacartProductCollection.Responses.$200>(
    `instacart/product_collections/${params.collection_id}`
  );

/**
 * campaign_collections
 */

/**
 * Bulk enable a Amazon campaign collections
 */
export const bulkEnableAmazonCampaignCollections = (
  params: Paths.BulkEnableAmazonCampaignCollections.RequestBody
) =>
  apicalls.post<
    Paths.BulkEnableAmazonCampaignCollections.RequestBody,
    Paths.BulkEnableAmazonCampaignCollections.Responses.$202
  >("ams/campaign_collections/bulk_enable", params);

/**
 * Bulk pause a Amazon campaign collections
 */
export const bulkPauseAmazonCampaignCollections = (
  params: Paths.BulkPauseAmazonCampaignCollections.RequestBody
) =>
  apicalls.post<
    Paths.BulkPauseAmazonCampaignCollections.RequestBody,
    Paths.BulkPauseAmazonCampaignCollections.Responses.$202
  >("ams/campaign_collections/bulk_pause", params);
